import { styled } from '@linaria/react';

export const BetContent = styled.div<{ isOpen: boolean }>`
  min-height: 59px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: #fff;
  position: relative;
  pointer-events: auto;

  &:after {
    position: absolute;
    bottom: 0;
    content: '';
    display: ${props => (props.isOpen ? 'none' : 'block')};
    height: 1px;
    background: var(--oc-line-secondary);
    border-radius: 1px;
    width: calc(100% - 30px);
  }

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);

      &:last-of-type {
        border-radius: 0 0 5px 5px;

        :after {
          display: none;
        }
      }
    }
  }
`;

export const BetNameWrapper = styled.div`
  height: 100%;
  user-select: none;
  flex-grow: 1;
  padding-right: 15px;
`;

export const BetBestOddsButtonWrapper = styled.div`
  min-height: 33px;
  min-width: 60px;
  padding: 3px 0;
  align-self: flex-start;
  z-index: var(--cxy-z-index-internal-base);
`;

export const BetColumnTopBetName = styled.span`
  display: block;
  font-size: 16px;
  font-weight: 600;
  user-select: none;
  line-height: 22px;
`;

export const SeeAllOdds = styled.button`
  display: flex;
  align-items: center;
  gap: 3px;
  font-family: var(--cxy-font-family-sans);
  font-size: 12px;
  font-weight: normal;
  line-height: 16px;
  color: var(--ogm-odds-grid-see-all-odds-color);
  cursor: pointer;

  span {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    color: inherit;
  }
`;
